import { createSelector } from '@reduxjs/toolkit';

const selectAsyncCalls = (state) => state.asyncTasks;

export const selectRelatedAsyncCall = (actId) =>
  createSelector(selectAsyncCalls, (state) => state.asyncCalls.filter((call) => call.id === actId));

export const selectAllAsyncCalls = () => createSelector(selectAsyncCalls, (state) => state.asyncCalls);
